import { useState, useEffect } from 'react';
import { changeDocTitle } from 'src/components/helpers';
import AGTable from 'src/components/table/aggrid';
import { WeddingRequestsRow } from 'src/components/common/rows/WeddingRequestsRow';
import styled from '@emotion/styled';
import { adminTableStyles } from 'src/assets/styles/components/AdminTable';
import FacilitateWeddingRequestAnswers from './facilitateWeddingRequestAnswers';

const WeddingRequestTable = styled('section')`
  ${adminTableStyles}
  min-width: 90%;
  height: 88vh;
`;

const AllFacilitatorWeddingRequests = (props) => {
  const { allWeddingRequests, getInfo, inputs, loading } = props;
  const [showWeddingRequestForm, set_showWeddingRequestForm] = useState(null);

  useEffect(() => {
    changeDocTitle('Solicitudes de Matrimonio');
  }, []);

  if (showWeddingRequestForm) {
    return (
      <FacilitateWeddingRequestAnswers
        answers={allWeddingRequests.find((form) => form.id === showWeddingRequestForm)}
        inputs={inputs}
        set_showWeddingRequestForm={set_showWeddingRequestForm}
        getInfo={getInfo}
      />
    );
  }

  return (
    <WeddingRequestTable>
      <p className="greet">
        Bienvenido {inputs?.role === 'facilitator' ? 'facilitador' : 'pastor'}
      </p>
      <div className="table">
        {!!loading && <div className="loading">Cargando...</div>}
        <AGTable
          rowData={allWeddingRequests}
          rowHeight={50}
          columnDefs={WeddingRequestsRow({ set_showWeddingRequestForm, loading })}
          suppressDragLeaveHidesColumns={false}
        />
      </div>
    </WeddingRequestTable>
  );
};

export default AllFacilitatorWeddingRequests;
